<template>
  <div class="menu-item-wrap">
    <!-- 選單 -->
    <section class="tab">
      <ul class="tab-wrap">
        <li
          v-for="(tab, index) in getTabList?.slice(0, getTabList?.length > 6 ? 5 : 6)"
          :key="index"
          @click="selectTab(tab)"
        >
          <p
            :class="[
              'tab-name',
              tab.label.replace(/\//g, '').toString().length > 5 ? 'tab-name-small' : '',
              chooseTab.value === tab.value ? 'tab-is-selected' : '',
            ]"
          >
            {{ tab.label.slice(0, 7) }}
          </p>
        </li>
        <li v-if="getTabList?.length > 6" @click="openDialog('moreTab')">
          <i class="bi bi-grid-3x3-gap-fill"></i>
        </li>
      </ul>
    </section>
    <!-- 選項 -->
    <section class="item">
      <div class="item-wrap">
        <!-- 往前箭頭 -->
        <cus-button
          color="gray-noFocus"
          v-if="getItemList.totalPage > 1 && currentPage !== 1"
          topIcon="arrow-left"
          topIconClass="arrow"
          @click="handlePage('prev')"
        ></cus-button>
        <!-- 項目 -->
        <cus-button
          color="gray-noFocus"
          v-for="(item, index) in copyAllItemList?.slice(itemStart, itemEnd)"
          :key="index"
          :text="item.label"
          :textClass="item.label.toString().length > 8 ? 'menu-item-text' : ''"
          @click="doSetItem(item)"
          :selected="chooseItem?.value === item.value ? true : false"
          :closeTransition="true"
          :style="
            item.position?.length > 0
              ? `grid-area:${item.position[0]}/${item.position[1]}/${item.position[0] + 2}/${item.position[1] + 2}`
              : ''
          "
        ></cus-button>
        <!-- 往後箭頭 -->
        <cus-button
          color="gray-noFocus"
          v-if="getItemList.totalPage > 1 && currentPage !== getItemList.totalPage"
          topIcon="arrow-right"
          topIconClass="arrow"
          @click="handlePage('next')"
        ></cus-button>
      </div>
    </section>
  </div>

  <!-- 更多選單彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useDialog } from '@/utils/dialog';
import { useGetters, useActions } from '@/utils/mapStore';
import { ref, computed, watch, defineAsyncComponent } from 'vue';
export default {
  name: 'menu-item',
  components: {
    MoreSelect: defineAsyncComponent(() => import('@/components/dialog/MoreSelect.vue')),
  },
  setup() {
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得清單
    const { getTabList, getItemList } = useGetters('list', ['getTabList', 'getItemList']);
    const itemList = useGetters('list', ['getItemList']);
    const copyAllItemList = computed(() => JSON.parse(JSON.stringify(itemList.value.data)));
    // console.log(copyAllItemList);
    //取得所選標籤
    const { chooseTab, chooseItem } = useGetters('menuItem', ['chooseTab', 'chooseItem']);
    //處理分頁
    const currentPage = ref(1);
    const handlePage = (action) => {
      switch (action) {
        case 'next':
          currentPage.value += 1;
          break;
        case 'prev':
          currentPage.value -= 1;
          break;
      }
    };
    //處理分頁slice的品項
    const itemStart = ref(0);
    const itemEnd = ref(30);
    watch(
      getItemList,
      () => {
        if (getItemList.value.totalPage > 1) itemEnd.value = 29;
        else itemEnd.value = 30;
      },
      { immediate: true }
    );
    watch(currentPage, () => {
      const x = (currentPage.value - 2) * 28 + 29 < 29 ? 0 : (currentPage.value - 2) * 28 + 29;
      const y = currentPage.value === 1 || currentPage.value === getItemList.value.totalPage ? 29 : 28;
      itemStart.value = x;
      itemEnd.value = x + y;
    });

    //選擇標籤
    const doSetTab = useActions('menuItem', ['doSetTab']);
    const selectTab = (tab) => {
      doSetTab(tab);
      currentPage.value = 1;
      closeDialog();
    };
    //選擇品項
    const doSetItem = useActions('menuItem', ['doSetItem']);

    return {
      dialogTemplate,
      openDialog,
      getTabList,
      getItemList,
      copyAllItemList,
      chooseTab,
      chooseItem,
      currentPage,
      itemStart,
      itemEnd,
      handlePage,
      selectTab,
      doSetItem,
    };
  },
};
</script>
<style lang="scss" scoped>
.menu-item-wrap {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 8% auto;
}
$tab-width: calc(100% / 6);
.tab-wrap {
  font-size: 2.2rem;
  height: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(6, $tab-width);
  .tab-name {
    margin: 0 auto;
    color: $color-blue;
  }
  .tab-name-small {
    font-size: 1.8rem;
  }
  .tab-is-selected {
    font-weight: 500;
    color: $color-green;
    // &::after {
    //   content: '';
    //   width: 75%;
    //   height: 4px;
    //   background: $color-blue;
    //   border-radius: 2px;
    //   position: absolute;
    //   bottom: -6px;
    //   left: 50%;
    //   transform: translateX(-50%);
    // }
  }
  .more {
    font-size: 2.8rem;
    transform: translateY(-0.05em);
    cursor: pointer;
  }
}
.item-wrap {
  // padding-top: 8px;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-auto-flow: row dense;
  :deep(.menu-item-text) {
    font-size: 1.8rem;
    -webkit-line-clamp: 3;
  }
  :deep(.arrow) {
    font-size: 3rem;
    -webkit-text-stroke: 0.5px $color-blue;
  }
}
</style>
